// Header.js
import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css'

const Header = () => {
    return (
      <header className="header">
        <h3>Picky WallS</h3>
        {/* <nav className='menu-btn'> */}
          {/* <Link to="/">Home</Link> */}

          
          {/* <Link to="/Aesthetic">Aesthetic</Link> */}
        {/* </nav> */}
      </header>
    );
  };
  

export default Header;
